import { render, staticRenderFns } from "./invoice-summary-invoice-no.vue?vue&type=template&id=3bff78fb&"
import script from "./invoice-summary-invoice-no.vue?vue&type=script&lang=js&"
export * from "./invoice-summary-invoice-no.vue?vue&type=script&lang=js&"
import style0 from "./invoice-summary-invoice-no.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VIcon})
